import { HttpErrorResponse } from '@angular/common/http';

/**
 * The backend refuses an unassigned caller on the CRL read endpoints
 * (`/client-request/page`, `/client-request/item/detail`) with:
 *
 *   - 403 — unassigned contact caller (PP-3817 backend);
 *   - 404 — deleted/unknown request or item;
 *   - 400 with `extensions.details.reason === 'IllegalStateTenantException'` —
 *     the legacy refusal shape, kept until every environment runs the 403
 *     backend.
 *
 * Anything else (500, network, other 400s — including the secure-link
 * no-grants refusal, which carries no `reason`) is NOT a no-access failure and
 * must keep the normal error-state behavior.
 */
export function isCrlNoAccessError(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) return false;
  if (error.status === 403 || error.status === 404) return true;
  if (error.status !== 400) return false;
  const reason = (error.error as { extensions?: { details?: { reason?: string } } } | null)?.extensions?.details?.reason;
  return reason === 'IllegalStateTenantException';
}
